export default __webpack_public_path__ + "static/media/idea-white.f0a46bd9.svg";